import {createContext} from 'react';

import type {RouteConfigs} from 'src/types';

const RouteConfigsContext = createContext<RouteConfigs>({});

export default RouteConfigsContext;
